<template>
  <div class="view-loading" :style="{ 'transition-delay': delay }">
    <div class="view-loading__container">
      <div class="view-loading__logo">
        <AtlastiLogo />
      </div>

      <TextBox
        v-if="error"
        type="error"
        class="view-loading__error"
        :title="$t('notification.generalError')"
        :text="`${$t('notification.serverError')} ${$t('problemContactSupport')}`"
      >
        <template #icon><InfoIcon16 /></template>
      </TextBox>
      <div v-else class="view-loading__title">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import AtlastiLogo from '@/components/NavBar/AtlastiLogo.vue';
import TextBox from '@/components/TextBox.vue';
import InfoIcon16 from '@/components/Icons/InfoIcon16.vue';
import i18n from '@/i18n';

export default defineComponent({
  name: 'ViewLoading',

  components: {
    AtlastiLogo,
    TextBox,
    InfoIcon16,
  },
  props: {
    delay: {
      type: String,
      default: null,
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },

    text: {
      type: String,
      required: false,
      default(): string {
        return i18n.global.t('project.loading.title');
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.view-loading {
  height: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.view-loading__container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.view-loading__error {
  width: 400px;
}

.view-loading__logo {
  width: 48px;
  margin-bottom: 24px;
}

.view-loading__title {
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #3d4045;
}
</style>
